import {Button, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {isProductBuyable} from "../../utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {useAuth} from "../../context/auth-context";
import {getUrl, PWAUrls} from "../../config/urls";
import {useAddToCart, useRemoveFromCart} from "../../hooks/useCart";
import {toast} from "react-toastify";

const TopoAddToCart = ({t, i18n, topo, unlocked, setShowAuthAlert}) => {
    const auth = useAuth();

    const { data: dataRemoveFromCart , mutateAsync: mutateRemoveFromCart, status: statusRemoveFromCart, error: errorRemoveFromCart } = useRemoveFromCart(i18n.language, t('App.screens.CartScreen.removedFromCart'));
    const { data: dataAddToCart , mutateAsync: mutateAddToCart, status: statusAddToCart, error: errorAddToCart }   = useAddToCart(i18n.language, t('App.screens.CartScreen.addedToCart'));
    const addToCart = (product) => {
        try {
            mutateAddToCart(product);
        } catch (e) {
            toast.error(t('common.error.save'));
        }
    }
    const removeFromCart = (product) => {
        try {
            mutateRemoveFromCart(product);
        } catch (e) {
            toast.error(t('common.error.save'));
        }
    }

    const link = getUrl(PWAUrls.TOPO, {lng: i18n.language, slug: topo.slug});
    const validationLink = getUrl(PWAUrls.TOPO_VALIDATION, {lng: i18n.language, slug: topo.slug});

    return (
        <div className={"button-wrapper text-center"}>
            {unlocked &&
            <Button
                component={Link}
                to={link}
                variant="contained"
                color="primary"
            >
                {t("TopoAddToCart.accessGuidebook")}
            </Button>
            }
            {!unlocked && topo.isQuestionable &&
            <>
                <Button
                    component={Link}
                    to={validationLink}
                    variant="contained"
                    color="primary"
                >
                    {t("TopoAddToCart.unlockGuidebook")}
                </Button>
                <Typography variant="subtitle2"
                            gutterBottom>{t("TopoAddToCart.unlockDigitalGuidebook")}</Typography>
            </>
            }
            {!unlocked &&
            <div className={'row mt-3'}>
                {isProductBuyable(topo.virtualProduct) && <>
                    {!auth.isInCart(topo.virtualProduct) && !auth.isInCart(topo.physicalProduct) &&
                    <div className={'col-lg text-center'}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<FontAwesomeIcon icon="mobile-alt"/>}
                            disabled={statusAddToCart === 'pending'}
                            onClick={() => {
                                if (auth.isAuthenticated) {
                                    addToCart(topo.virtualProduct);
                                } else {
                                    setShowAuthAlert(true);
                                }
                            }}
                        >
                            {topo.virtualProduct.priceLabel}
                        </Button>
                        <Typography variant="subtitle2"
                                    gutterBottom>{t("TopoAddToCart.buyDigitalVersion")}</Typography>
                    </div>
                    }
                    {auth.isInCart(topo.virtualProduct) &&
                    <div className={'col-lg text-center'}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={
                                <FontAwesomeIcon icon={["fas", 'shopping-cart']}/>
                            }
                            disabled={statusRemoveFromCart === 'pending'}
                            onClick={() => {
                                removeFromCart(topo.virtualProduct);
                            }}
                        >
                            {topo.virtualProduct.priceLabel}
                        </Button>
                        <Typography variant="subtitle2"
                                    gutterBottom>{t("TopoAddToCart.buyDigitalVersion")}</Typography>
                    </div>
                    }
                    {!isProductBuyable(topo.physicalProduct) && <div className={'col-lg text-center'}>
                    <Typography variant="subtitle2"
                                gutterBottom>{t("TopoAddToCart.digitalVersionOnly")}</Typography>
                    </div>}
                </>}
                {isProductBuyable(topo.physicalProduct) && <div className={'col-lg text-center'}>
                    {!auth.isInCart(topo.physicalProduct) &&
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<FontAwesomeIcon icon={["fas", 'book']}/>}
                        disabled={statusAddToCart === 'pending'}
                        onClick={() => {
                            if (auth.isAuthenticated) {
                                if (isProductBuyable(topo.virtualProduct) && auth.isInCart(topo.virtualProduct)) {
                                    auth.removeFromCart(topo.virtualProduct, false);
                                }
                                addToCart(topo.physicalProduct);
                            } else {
                                setShowAuthAlert(true);
                            }
                        }}
                    >
                        {topo.physicalProduct.priceLabel}
                    </Button>
                    }
                    {auth.isInCart(topo.physicalProduct) &&
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={
                            <FontAwesomeIcon icon={["fas", 'book']}/>
                        }
                        disabled={statusRemoveFromCart === 'pending'}
                        onClick={() => {
                            removeFromCart(topo.physicalProduct);
                        }}
                    >
                        {topo.physicalProduct.priceLabel}
                    </Button>
                    }
                    <Typography variant="subtitle2"
                                gutterBottom>{t("TopoAddToCart.buyGuidebook")}</Typography>
                </div>}
            </div>
            }
        </div>
    );
}

export default compose(
    withTranslation()
)(TopoAddToCart);
